import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PredictorLead {
  parent_full_name: string;
  student_name: string;
  email: string;
  phone: string;
  standard: string;
}

const STORAGE_KEY = 'sehyog_predictor_lead';

/**
 * Saves the free-predictor lead and remembers on this browser that it was
 * given, so returning visitors go straight to the predictor.
 */
@Injectable({ providedIn: 'root' })
export class PredictorLeadService {
  private readonly baseUrl = environment.baseURL;

  constructor(private http: HttpClient) {}

  save(lead: PredictorLead): Observable<any> {
    return this.http.post(this.baseUrl + 'api/f/parent-student-enquiry/add', lead);
  }

  remember(lead: PredictorLead): void {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(lead)); } catch { /* private mode */ }
  }

  saved(): PredictorLead | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) as PredictorLead : null;
    } catch {
      return null;
    }
  }
}
